var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "share-interaction-c" },
    [
      _c("Like", { attrs: { likeData: _vm.likeData } }),
      _vm._v(" "),
      _c("div", { staticClass: "comment-wrap", attrs: { id: "leftComment" } }, [
        _c("div", { staticClass: "item" }, [
          _c("img", { attrs: { src: _vm.commentIcon } }),
          _vm._v(" "),
          _vm.showFirstComment
            ? _c("div", { staticClass: "first-comment-tag" }, [
                _vm._v("抢首评"),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "count comment-count" }),
      ]),
      _vm._v(" "),
      _c("Collection", { attrs: { collectionData: _vm.collectionData } }),
      _vm._v(" "),
      _c("Share"),
      _vm._v(" "),
      _c("PhoneScan"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }